// Update referrer fields
export function updateReferrerFields() {
  const referrer = window.location.href;
  document.querySelectorAll('.referrer').forEach((element) => {
    element.value = referrer;
  });
}
